
import React from 'react';
import { useLocation, Link } from 'react-router-dom';
import { CheckCircle, Mail } from 'lucide-react';
import { Card, CardContent, CardDescription, CardFooter, CardHeader, CardTitle } from "@/components/ui/card";
import { Button } from "@/components/ui/button";
import Navbar from '@/components/Navbar';
import Footer from '@/components/Footer';

const RegistrationSuccess = () => {
  const location = useLocation();
  const { email } = location.state || { email: '' };

  return (
    <div className="flex min-h-screen flex-col">
      <Navbar />
      <div className="flex-1 py-12">
        <div className="container max-w-md mx-auto">
          <Card>
            <CardHeader className="space-y-1">
              <div className="flex justify-center mb-4">
                <div className="bg-green-100 p-3 rounded-full">
                  <CheckCircle className="h-12 w-12 text-green-600" />
                </div>
              </div>
              <CardTitle className="text-2xl text-center">Sikeres regisztráció</CardTitle>
              <CardDescription className="text-center">
                Köszönjük, hogy regisztrált a Medihub rendszerében!
              </CardDescription>
            </CardHeader>
            <CardContent className="space-y-4 text-center">
              <p>
                A fiókja sikeresen létrehozva. Mielőtt azonban bejelentkezhetne, kérjük, erősítse meg e-mail címét.
              </p>
              
              {email && (
                <div className="p-4 bg-blue-50 rounded-lg flex items-center justify-center gap-2">
                  <Mail className="h-5 w-5 text-blue-500" />
                  <p className="text-blue-700">
                    Ellenőrző e-mailt küldtünk a következő címre: <strong>{email}</strong>
                  </p>
                </div>
              )}
              
              <p>
                Kérjük, keresse meg az emailt és kattintson a benne található megerősítő linkre a fiókja aktiválásához.
              </p>
            </CardContent>
            <CardFooter className="flex flex-col gap-4">
              <Button asChild className="w-full">
                <Link to="/login">Tovább a bejelentkezéshez</Link>
              </Button>
              <div className="text-sm text-center text-muted-foreground">
                Nem kapta meg az e-mailt? <Link to="/resend-verification" className="underline font-medium">Ellenőrző e-mail újraküldése</Link>
              </div>
            </CardFooter>
          </Card>
        </div>
      </div>
      <Footer />
    </div>
  );
};

export default RegistrationSuccess;
